module.exports = __webpack_public_path__ + "static/img/user_image.b7116ad.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_image.jpeg
// module id = skXs
// module chunks = 3